// extracted by mini-css-extract-plugin
module.exports = {"builderContent":"SearchPage_builderContent__GB4fF"};